import {array, boolean, number, object, string} from 'yup';

export const managedMethodV8nSchema = object().shape({
  id: string().required(),
  name: string().required(),
  currency: string().required(),
  provider: string().required(),
  token_code: string().required(),
  enabled: boolean().required(),
  sort_order: number().integer().required(),
  country: string().nullable(),
});

export const v8nSchemaOfListManagedMethodsResponse = object().shape({
  array: array().of(managedMethodV8nSchema).required(),
});
